import { render, staticRenderFns } from "./CkEditorBlock.vue?vue&type=template&id=2bfeb81e&"
import script from "./CkEditorBlock.vue?vue&type=script&lang=js&"
export * from "./CkEditorBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports